<template>
  <main class="app-main">
    <!--begin::App Content Header-->
    <div class="app-content-header">
      <div class="container-fluid">
        <div class="row">
          <div class="col-sm-6"><h3 class="mb-0">الإيجارات المتأخرة</h3></div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-end">
              <li class="breadcrumb-item"><router-link to="/">الرئيسية</router-link></li>
              <li class="breadcrumb-item active" aria-current="page">الإيجارات المتأخرة</li>
            </ol>
          </div>
        </div>
      </div>
    </div>
    <!--end::App Content Header-->
    <div class="app-content">
      <!--FILTER-->
      <div class="card shadow card-warning card-outline mt-5">
        <div class="card-header">
          <button
            class="filter-btn w-100 text-start collapse-toggle"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#filterCard"
            aria-expanded="false"
            aria-controls="filterCard"
          >
            <i class="fa-solid fa-magnifying-glass"></i> بحث وتصفية
          </button>
        </div>

        <div class="collapse" id="filterCard">
          <form action="" @submit.prevent="filterSubmit">
            <div class="card-body">
              <div class="row">
                <div class="col-6 col-sm-3 mb-3">
                  <input type="text" v-model="searchPropertyTitle" class="form-control" placeholder="اسم العقار">
                </div>
                <div class="col-6 col-sm-3 mb-3">
                  <select class="form-control" v-model="searchRegion" @change="getCitiesList">
                    <option :value="null">المنطقة</option>
                    <option v-for="r in regionsList" :value="r.id" :key="r.id">{{ r.name }}</option>
                  </select>
                </div>
                <div class="col-6 col-sm-3 mb-3">
                  <select ref="citiesSelect" class="form-control" v-model="searchCity" :disabled="!searchRegion">
                    <option :value="null">المدينة</option>
                    <option v-for="c in citiesList" :value="c.id" :key="c.id">{{ c.name }}</option>
                  </select>
                </div>
                <div class="col-6 col-sm-3 mb-3">
                  <input type="number" min="0" v-model="searchMinAmount" class="form-control" placeholder="أقل مبلغ مستحق">
                </div>
                <div class="col-6 col-sm-3 mb-3">
                  <input type="number" min="0" v-model="searchMaxAmount" class="form-control" placeholder="أعلى مبلغ مستحق">
                </div>
              </div>
              <div
                class="d-flex align-items-center justify-content-between p-2 mb-2 rounded border"
                @click="showDateFilter = !showDateFilter"
                style="cursor:pointer; transition:0.3s;"
                :class="showDateFilter ? 'bg-light border-primary' : ''"
              >
                <div class="d-flex align-items-center gap-2">
                  <i class="bi bi-calendar fs-5 text-primary"></i>
                  <span class="fw-bold">تاريخ الاستحقاق</span>
                </div>
                <div>
                  <i :class="showDateFilter ? 'bi bi-chevron-up' : 'bi bi-chevron-down'"></i>
                </div>
              </div>
              <div v-if="showDateFilter" class="row">
                <div class="col-6 col-sm-3 mb-3">
                  <label class="form-label">تاريخ الاستحقاق من</label>
                  <input type="date" v-model="searchDueDateFrom" class="form-control">
                </div>
                <div class="col-6 col-sm-3 mb-3">
                  <label class="form-label">تاريخ الاستحقاق إلى</label>
                  <input type="date" v-model="searchDueDateTo" class="form-control">
                </div>
              </div>
            </div>
            <div class="card-footer">
              <div class="row">
                <div class="col text-end">
                  <button type="submit" class="btn btn-warning btn-sm"><i class="fa-solid fa-filter"></i> بحث وتصفية</button>
                  <button type="button" class="btn btn-light btn-sm ms-3" @click.prevent="clearFilter"><i class="fa-solid fa-filter-circle-xmark"></i> إلغاء</button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>

      <div class="container-fluid">
        <div class="row">
          <div class="col">
            <div class="card card-secondary card-outline mb-4 mt-5">
              <div class="card-header d-flex align-items-center">
                <div class="card-title mb-0">
                  <i class="bi bi-exclamation-triangle-fill me-1 text-danger"></i> الإيجارات المتأخرة
                </div>
                <span v-if="countRows > 0"
                  class="badge rounded-pill bg-danger fs-6 px-3 py-2 ms-auto">
                  عدد النتائج ( {{ countRows }} )</span>
              </div>
              <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
              <div class="card-body">
                <mainLoader v-if="mainLoading" />
                <div v-else-if="!rows.length" class="text-center text-muted py-5">
                  لا توجد إيجارات متأخرة تطابق الفلتر المحدد
                </div>
                <div v-else class="row">
                  <div class="col">
                    <div class="table-responsive">
                      <table class="table table-striped">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>العقار</th>
                            <th>إجمالي المبلغ المستحق</th>
                            <th>أقدم تاريخ استحقاق</th>
                            <th>التأخر</th>
                            <th>الدفعات المتأخرة</th>
                            <th>يوجد رفع قضية</th>
                            <th>العمليات</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="row in rows" :key="row.propertyId">
                            <td>#{{ row.propertyId }}</td>
                            <td class="ellipsis-cell">
                              <span v-if="row.Properties">{{ row.Properties.title || 'عقار #' + row.Properties.id }}</span>
                              <span v-else class="text-muted">—</span>
                            </td>
                            <td style="white-space:nowrap;font-weight:600;color:#ef4444;">
                              {{ Number(row.totalAmount).toLocaleString() }} ر.س
                            </td>
                            <td>{{ $shortDate(row.dueDate) }}</td>
                            <td>
                              <span class="badge" :class="overdueSeverityClass(row.dueDate)">
                                {{ overdueDays(row.dueDate) }} يوم
                              </span>
                            </td>
                            <td>
                              <span class="badge" :class="row.overdueCount > 3 ? 'bg-danger' : row.overdueCount > 1 ? 'bg-warning text-dark' : 'bg-success'">
                                {{ row.overdueCount }} دفعة
                              </span>
                            </td>
                            <td>
                              <span v-if="row.Properties && row.Properties.hasLawsuit" class="badge bg-danger">
                                <i class="bi bi-bank me-1"></i> نعم
                              </span>
                              <span v-else class="badge bg-secondary">لا</span>
                            </td>
                            <td>
                              <router-link
                                v-if="row.Properties"
                                :to="`/properties/update/${row.Properties.id}`"
                                class="btn btn-light btn-sm"
                              ><i class="fa-regular fa-eye"></i></router-link>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-footer">
                <div class="row">
                  <div class="col">
                    <ul class="pagination">
                      <li v-if="currentPage > 1" class="page-item"><a class="page-link" href="#" @click.prevent="prevPage()">السابق</a></li>
                      <li v-for="p in pages" :key="p" class="page-item">
                        <a v-if="p == currentPage" class="page-link active" href="javascript:void(0)">{{ p }}</a>
                        <a v-else class="page-link" href="javascript:void(0)" @click="goToPage(p)">{{ p }}</a>
                      </li>
                      <li v-if="rows.length >= 30" class="page-item"><a class="page-link" href="#" @click.prevent="nextPage()">التالي</a></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>

import $ from 'jquery';
window.$ = $;
window.jQuery = $;
import 'select2';
import 'select2/dist/css/select2.min.css';

export default {
  name: 'OverdueRentals',
  data() {
    return {
      mainLoading: true,
      hasError: false,
      message: '',
      errorNumber: 0,
      rows: [],
      pages: [],
      countRows: 0,
      currentPage: parseInt(this.$route.query.page) || 1,
      regionsList: [],
      citiesList: [],
      searchPropertyTitle: this.$route.query.propertyTitle || '',
      searchRegion: this.$route.query.regionId ? parseInt(this.$route.query.regionId) : null,
      searchCity: this.$route.query.cityId ? parseInt(this.$route.query.cityId) : null,
      searchMinAmount: this.$route.query.minAmount || '',
      searchMaxAmount: this.$route.query.maxAmount || '',
      searchDueDateFrom: this.$route.query.dueDateFrom || null,
      searchDueDateTo: this.$route.query.dueDateTo || null,
      showDateFilter: false,
    };
  },
  methods: {
    overdueDays(dueDate) {
      const diff = Math.floor((new Date() - new Date(dueDate)) / (1000 * 60 * 60 * 24));
      return diff > 0 ? diff : 0;
    },
    overdueSeverityClass(dueDate) {
      const days = this.overdueDays(dueDate);
      if (days > 30) return 'bg-danger';
      if (days > 7) return 'bg-warning text-dark';
      return 'bg-secondary';
    },
    getList() {
      this.mainLoading = true;
      let urlQuery = [`page=${this.currentPage}`];

      if (this.searchPropertyTitle.trim() !== '')
        urlQuery.push(`propertyTitle=${encodeURIComponent(this.searchPropertyTitle.trim())}`);
      if (this.searchRegion)
        urlQuery.push(`regionId=${this.searchRegion}`);
      if (this.searchCity)
        urlQuery.push(`cityId=${this.searchCity}`);
      if (this.searchMinAmount !== '')
        urlQuery.push(`minAmount=${this.searchMinAmount}`);
      if (this.searchMaxAmount !== '')
        urlQuery.push(`maxAmount=${this.searchMaxAmount}`);
      if (this.searchDueDateFrom)
        urlQuery.push(`dueDateFrom=${this.searchDueDateFrom}`);
      if (this.searchDueDateTo)
        urlQuery.push(`dueDateTo=${this.searchDueDateTo}`);

      this.hasError = false;

      this.$router.replace({ query: {
        page: this.currentPage,
        ...(this.searchPropertyTitle.trim() !== '' ? { propertyTitle: this.searchPropertyTitle.trim() } : {}),
        ...(this.searchRegion ? { regionId: this.searchRegion } : {}),
        ...(this.searchCity ? { cityId: this.searchCity } : {}),
        ...(this.searchMinAmount !== '' ? { minAmount: this.searchMinAmount } : {}),
        ...(this.searchMaxAmount !== '' ? { maxAmount: this.searchMaxAmount } : {}),
        ...(this.searchDueDateFrom ? { dueDateFrom: this.searchDueDateFrom } : {}),
        ...(this.searchDueDateTo ? { dueDateTo: this.searchDueDateTo } : {}),
      }}).catch(() => {});

      this.$http.get(`/api/admin/home/overdueRentals?${urlQuery.join('&')}`)
        .then(({ data }) => {
          this.rows = data.rows;
          this.pages = data.pages ?? [this.currentPage];
          this.countRows = data.countRows ?? 0;
          this.regionsList = data.regionsList ?? this.regionsList;
          this.mainLoading = false;
        })
        .catch(err => {
          [this.message, this.errorNumber] = this.$globalError(err, true);
          this.hasError = true;
          this.mainLoading = false;
          window.scrollTo({ top: 0, behavior: 'smooth' });
        });
    },
    getCitiesList(resetCity = true) {
      if (resetCity) {
        this.citiesList = [];
        this.searchCity = null;
      }
      if (!this.searchRegion) return;
      this.$http.get(`/api/admin/cities/list?regionId=${this.searchRegion}&all=1`).then(({ data }) => {
        this.citiesList = data.cities;
        this.$nextTick(() => {
          this.applySelect2Cities();
        });
      }).catch(() => {});
    },
    nextPage() {
      this.currentPage += 1;
      this.getList();
    },
    prevPage() {
      this.currentPage -= 1;
      this.getList();
    },
    goToPage(num) {
      this.currentPage = num;
      this.getList();
    },
    filterSubmit() {
      this.currentPage = 1;
      this.getList();
    },
    clearFilter() {
      this.currentPage = 1;
      this.searchPropertyTitle = '';
      this.searchRegion = null;
      this.searchCity = null;
      this.citiesList = [];
      this.searchMinAmount = '';
      this.searchMaxAmount = '';
      this.searchDueDateFrom = null;
      this.searchDueDateTo = null;
      this.$router.replace({ query: {} }).catch(() => {});
      this.getList();
    },
    applySelect2Cities(){
      const myInstance = this;
      if(!this.$refs.citiesSelect){
        setTimeout(() => {
          this.applySelect2Cities();
        }, 200);
        return;
      }
      $(this.$refs.citiesSelect).select2({width: '100%'})
      .on("change", function () {
        myInstance.searchCity = $(this).val();
      });
    },
  },
  created() {
    if (this.searchRegion) this.getCitiesList(false);
    this.getList();
  },
};
</script>

<style scoped>
.ellipsis-cell {
  max-width: 260px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>